import { Mic } from 'lucide-react';
import type { MicAccess } from '../audio/recorder';
import { MicNote } from './MicNote';

interface Props {
  title: string;
  body: string;
  access: MicAccess | null;
  /** Offered when recording could still work: turn the record button back on. */
  onRetry?: () => void;
}

/** In place of the record button: speak aloud anyway, why recording is off, and a way back to it. */
export function NoMicPanel({ title, body, access, onRetry }: Props) {
  const canRetry = onRetry && access !== 'unsupported' && access !== 'insecure';
  return (
    <div className="panel-quiet stack">
      <p className="section-title">{title}</p>
      <p className="muted">{body}</p>
      <MicNote access={access} />
      {canRetry && (
        <button type="button" className="btn btn-ghost small" style={{ alignSelf: 'flex-start', marginLeft: -12 }} onClick={onRetry}>
          <Mic size={16} aria-hidden="true" /> {access === 'denied' ? 'Try the microphone again' : 'Record myself instead'}
        </button>
      )}
    </div>
  );
}
